const statuses = ['default', 'info', 'success', 'warning', 'danger']
const operationalStatuses = ['pending', 'running', 'success', 'warning', 'danger']

const field = (key, label, type, defaultValue, options, span) => ({
  key,
  label,
  type,
  default: defaultValue,
  options,
  span
})

export const statusAlert = {
  name: 'Status Alert',
  minW: 6,
  minH: 2,
  fields: [
    field('title', 'Title', 'text', 'Cycle at risk'),
    field('message', 'Message', 'textarea', 'Review the items requiring action.'),
    field('status', 'Status', 'select', 'warning', statuses),
    field('actionLabel', 'Action Label', 'text', 'Review items')
  ]
}

export const metric = {
  name: 'Metric',
  minW: 3,
  minH: 2,
  fields: [
    field('label', 'Label', 'text', 'Cycle completion'),
    field('value', 'Value', 'text', '78%'),
    field('helper', 'Helper Text', 'text', 'On track'),
    field('icon', 'Font Awesome Icon', 'text', ''),
    field('status', 'Status', 'select', 'info', statuses)
  ]
}

export const widgetPanel = {
  name: 'Widget Panel',
  minW: 5,
  minH: 4,
  fields: [
    field('title', 'Title', 'text', 'Panel'),
    field('content', 'Content', 'textarea', 'Add panel content.'),
    field('actionLabel', 'Action Label', 'text', '')
  ]
}

export const progressList = {
  name: 'Progress List',
  minW: 6,
  minH: 5,
  fields: [],
  itemFields: [
    field('label', 'Label', 'text', 'New stage', undefined, 12),
    field('detail', 'Detail', 'text', '', undefined, 12),
    field('value', 'Value', 'number', 0, undefined, 8),
    field('total', 'Total', 'number', 1, undefined, 8),
    field('status', 'Status', 'select', 'default', statuses, 8)
  ],
  defaultItems: [
    { label: 'Carrier bills received', detail: 'One expected tomorrow', value: 14, total: 15, status: 'default' }
  ]
}

export const readinessChecklist = {
  name: 'Readiness Checklist',
  minW: 4,
  minH: 5,
  fields: [
    field('actionLabel', 'Action Label', 'text', 'Close cycle'),
    field('actionDisabled', 'Action Disabled', 'boolean', true),
    field('actionIcon', 'Font Awesome Icon', 'text', '')
  ],
  itemFields: [
    field('label', 'Label', 'text', 'New check', undefined, 12),
    field('meta', 'Meta', 'text', '', undefined, 6),
    field('status', 'Status', 'select', 'pending', operationalStatuses, 6)
  ],
  defaultItems: [
    { label: 'All expected items received', meta: 'Pending', status: 'warning' }
  ]
}

export const attentionTable = {
  name: 'Attention Table',
  minW: 6,
  minH: 5,
  fields: [],
  itemFields: [
    field('priority', 'Priority', 'text', 'Blocking', undefined, 8),
    field('priorityType', 'Priority Type', 'select', 'danger', statuses, 8),
    field('age', 'Age', 'text', '', undefined, 8),
    field('item', 'Item', 'text', 'Item requiring attention', undefined, 12),
    field('detail', 'Detail', 'text', '', undefined, 12),
    field('actionLabel', 'Action Label', 'text', 'Review', undefined, 24)
  ],
  defaultItems: [
    { priority: 'Blocking', priorityType: 'danger', item: 'Item requiring attention', detail: '', age: 'Now', actionLabel: 'Review' }
  ]
}

export const activityList = {
  name: 'Activity List',
  minW: 4,
  minH: 4,
  fields: [],
  itemFields: [
    field('label', 'Label', 'text', 'Background task', undefined, 12),
    field('detail', 'Detail', 'text', '', undefined, 12),
    field('status', 'Status', 'select', 'running', operationalStatuses, 12),
    field('progress', 'Progress', 'number', 0, undefined, 12)
  ],
  defaultItems: [
    { label: 'Background task', detail: 'Running', status: 'running', progress: 50 }
  ]
}
